module.exports = __webpack_public_path__ + "static/media/puffdaddy.bfef52d2.mov";